import { useQuery } from '@tanstack/react-query'
import { apiClient } from '@workspace/public-utils'

export interface CompanyInfo {
  name?: string | null
  contact_email?: string | null
  contact_number?: string | null
  contact_number_secondary?: string | null
  working_hours?: string | null
  address?: string | null
  business_registration_number?: string | null
  ecommerce_registration_number?: string | null
  owner?: string | null
  bank_infos?: Array<{
    bank_name: string
    account_number: string
    account_holder: string
    bank_logo_url?: string
  }>
  extra_bottom_images?: string[]
}

export default function useCompanyInfo() {
  return useQuery({
    queryKey: ['lottomd', 'company-info'],
    queryFn: async ({ signal }) =>
      (await apiClient.get<CompanyInfo>('/api/v1/public/company-info', { signal })).data,
    staleTime: 5 * 60 * 1000,
  })
}
